import request from '@/utils/http.js';

const getTopicList = params => {
  return request({
    url: '/v3/vss/chatbot/get-topic-list',
    // url: '/mock/101/v3/vss/chatbot/get-topic-list',
    method: 'POST',
    data: {
      ...params
    }
  });
};
//复制ai聊天主题
const copyTopic = params => {
  return request({
    url: '/v3/vss/chatbot/copy-topic',
    method: 'POST',
    data: {
      ...params
    }
  });
}
//获取ai聊天主题详情
const getTopicDetail = params => {
  return request({
    url: '/v3/vss/chatbot/get-topic-detail',
    method: 'POST',
    data: {
      ...params
    }
  });
}
//获取随机头像昵称
const getBotRandom = params => {
  return request({
    url: '/v3/vss/chat/random-sock-puppet',
    method: 'GET',
    params
  });
}
//保存ai聊天主题
const saveTopic = params => {
  return request({
    url: '/v3/vss/chatbot/save-topic',
    method: 'POST',
    data: {
      ...params
    }
  });
}
//删除ai聊天主题
const deleteTopic = params => {
  return request({
    url: '/v3/vss/chatbot/delete-topic',
    method: 'POST',
    data: {
      ...params
    }
  });
}

const checkImportBot = params => {
  return request({
    url: '/v3/vss/chatbot/check-import',
    method: 'POST',
    data: {
      ...params
    }
  });
}
// 定义一个函数startPushTopic，接收一个参数params
const startPushTopic = params => {
  // 发送一个POST请求，请求的URL为'/v3/vss/chatbot/start-push-topic'
  return request({
    url: '/v3/vss/chatbot/start-push-topic',
    // 请求的方法为POST
    method: 'POST',
    // 请求的数据为params
    data: {
      ...params
    }
  });
};

const stopPushTopic = params => {
  return request({
    url: '/v3/vss/chatbot/end-push-topic',
    method: 'POST',
    data: {
      ...params
    }
  });
};

const getVirtualList = params => {
  return request({
    // url: '/mock/101/v3/vss/chatbot/get-virtual-audience-list',
    url: '/v3/vss/chatbot/get-virtual-audience-list',
    method: 'POST',
    data: {
      ...params
    }
  });
};

const getBotList = params => {
  return request({
    // url: '/mock/101/v3/vss/chatbot/get-chatbot-list',
    url: '/v3/vss/chatbot/get-chatbot-list',
    method: 'POST',
    data: {
      ...params
    }
  });
};

const pushMessage = params => {
  return request({
    url: '/v3/vss/chatbot/push-message',
    method: 'POST',
    data: {
      ...params
    }
  });
};

//发起端-聊天-获取常用语列表
const getPhraseList = params => {
  return request({
    url: '/v3/vss/chat/get-phrase-list',
    method: 'POST',
    data: {
      ...params
    }
  });
}
//观看端-聊天-获取常用语列表
const getPhraseSimpleList = params => {
  return request({
    url: '/v3/vss/chat/get-phrase-simple-list',
    method: 'POST',
    data: {
      ...params
    }
  });
}
//发起端-聊天-保存常用语
const savePhrase = params => {
  return request({
    url: '/v3/vss/chat/save-phrase',
    method: 'POST',
    data: {
      ...params
    }
  });
}
//发起端-聊天-删除常用语
const deletePhrase = params => {
  return request({
    url: '/v3/vss/chat/delete-phrase',
    method: 'POST',
    data: {
      ...params
    }
  });
}
//发起端-AI聊天-推送机器人消息
const pushChatbotMessage = params => {
  return request({
    url: '/v3/vss/chatbot/push-message',
    method: 'POST',
    data: {
      ...params
    }
  });
}
export default {
  getTopicList,
  copyTopic,
  getTopicDetail,
  getBotRandom,
  saveTopic,
  deleteTopic,
  checkImportBot,
  startPushTopic,
  stopPushTopic,
  getVirtualList,
  pushMessage,
  getBotList,
  getPhraseList,
  getPhraseSimpleList,
  savePhrase,
  deletePhrase,
  pushChatbotMessage
};
